import { Column, GridApi } from 'ag-grid-community';
import { observer } from 'mobx-react-lite';

import { useInstance } from 'app/libs/use-instance';

import { GenericFilterComponent } from '../filters';
import { useFilterModel } from './use-filter-model';

type FilterCollapsePanelProps = {
  column: Column;
  gridApi: GridApi;
};
export const FilterComponent = observer(
  ({ column, gridApi }: FilterCollapsePanelProps) => {
    const [model, setModel] = useFilterModel({ column, gridApi });
    const userColDef = useInstance(() => column.getUserProvidedColDef());

    const FilterComponent: GenericFilterComponent = userColDef?.filter;

    const handleModelChange = (model: any) => {
      setModel(model);
    };

    return FilterComponent ? (
      <FilterComponent
        column={column}
        model={model}
        onModelChange={handleModelChange}
      />
    ) : null;
  },
);
